export default {
  "privacy-policy": "https://www.vodafone.co.uk/privacy",
  "terms-and-conditions":
    "https://www.vodafone.co.uk/terms-and-conditions/consumer/mobile/pay-monthly/entertainment/Vodafone-entertainment/",
  "help-and-support": "http://support.vodafone.co.uk/",
  "cookie-preferences": "cookie-preferences",
};
